type SearchRequest = { params?: { query?: string; filters?: string; facetFilters?: unknown } };

// True when every request carries no user intent (no text, no filter string, no facet filters)
// AND we are not in search mode. In search mode an empty query is a valid "show everything" search.
export const shouldSuppressEmptySearch = (requests: ReadonlyArray<SearchRequest>, isSearching: boolean): boolean => {
  if (isSearching) {
    return false;
  }
  return requests.every((req) => {
    const facetFilters = req.params?.facetFilters;
    const hasFacetFilters = Array.isArray(facetFilters) ? facetFilters.length > 0 : Boolean(facetFilters);
    return !req.params?.query && !req.params?.filters && !hasFacetFilters;
  });
};

// A query with no letters or digits (e.g. '%#&', '***') tokenizes to zero tokens in
// Typesense, which then falls back to a match-all scan and returns every document
// (DM-2485). Treat it as a query that matches nothing instead of sending it.
export const isTokenlessQuery = (query: string | undefined): boolean =>
  typeof query === 'string' && query.trim().length > 0 && !/[\p{L}\p{N}]/u.test(query);

export const emptySearchResponse = (requests: ReadonlyArray<SearchRequest>) => ({
  results: requests.map((req) => ({
    hits: [],
    nbHits: 0,
    nbPages: 0,
    page: 0,
    processingTimeMS: 0,
    hitsPerPage: 0,
    exhaustiveNbHits: false,
    query: req.params?.query ?? '',
    params: '',
  })),
});
